import React, { useState } from "react";
import Slider from "react-slick";
import ReactPlayer from 'react-player';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../scss/components/GenericBanner/slider.scss"
import style from '../../../scss/components/GenericBanner/slider';

const SimpleSlider = (props) => {
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');

    const openPopup = (url) => {
            if (url.toLowerCase().includes("youtube")) {
                setPopupOpen(true);
                setVideoUrl(url);
              } else {
                window.open(url);
              }
    };

    const closePopup = () => {
        setPopupOpen(false);
    };

    var settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnHover: true,
        pauseOnFocus: true,
    };
    let slider = props.sliderData
    
    return(
        <div>
            <Slider { ...settings }>
                {
                    slider.map((sliderData, index) => {
                        return (
                            <div className='image-container' key={ index } >
                                {/* <a style={{'width':'100%','height':'100%'}} href={sliderData.href}> */}
                                <img
                                    onClick={() => openPopup(sliderData.href)}
                                    src={ sliderData.url }
                                    alt={sliderData.alt}
                                    className='image-view'
                                />
                                {/* </a> */}
                            </div>
                        ) 
                    }) 
                }
            </Slider>
            {isPopupOpen && (
                <div className="video-popup" onClick={closePopup}>
                    <div className="popup-content">
                        <div class="video-container">
                            <iframe
                                title="Video Popup"
                                width="560"
                                height="315"
                                src={videoUrl}
                                frameborder="0"
                                allowfullscreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SimpleSlider;